import React from "react";
import { Chip } from "./Chip";
import { AMOUNTS } from "./constants";

export const Step1Amount = ({ value, onSelect }) => (
  <div>
    <h3 className="font-display text-2xl font-extrabold tracking-tight mb-1">How much do you need?</h3>
    <p className="text-sm text-[#052F24]/55 font-light mb-6">See your best options in 2 minutes.</p>
    <div className="grid grid-cols-3 gap-2.5">
      {AMOUNTS.map((a) => (
        <Chip key={a} active={value === a} onClick={() => onSelect(a)} testId={`amount-${a}`}>
          {a}
        </Chip>
      ))}
    </div>
  </div>
);
